export default __webpack_public_path__ + "6f8dcbb35c81387846422a06f4153f3b.jpg";